import React from 'react';
import MyAds from './layouts/myads';

import '../static/css/account.css';


class Account extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="container">
                <ul className="nav nav-tabs md-tabs nav-justified">
                    <li className="nav-item">
                        <a className="nav-link active" data-toggle="tab" href="#panel1" role="tab">Your Ads</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" data-toggle="tab" href="#panel2" role="tab">Messages</a>
                    </li>

                </ul>
                <div className="tab-content card" id="tabcard">

                    <div className="tab-pane fade in show active" id="panel1" role="tabpanel">

                        <MyAds/>
                    </div>

                    <div className="tab-pane fade" id="panel2" role="tabpanel">
                        <br/>
                        <h3 className="w-100 text-center">No Messages</h3>
                    </div>

                    <div className="tab-pane fade" id="panel3" role="tabpanel">
                        <br/>
                    </div>

                </div>
            </div>
        );
    }
}

export default Account;



// WEBPACK FOOTER //
// ./src/components/account.js